let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1ojnt")).then(() => parcelRequire('eU1pr'));